var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{ active: _vm.keyChild === _vm.activeIndexChild }},[_c('router-link',{attrs:{"to":`/category/${_vm.child.my_soco_sql_id}/${_vm.$options.filters.slug(_vm.child.name)}`},nativeOn:{"click":function($event){return _vm.selectChild.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.child.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }